module.exports = __webpack_public_path__ + "img/2_Dicks_Screen_3_R.6e7883b9.jpg";